// extracted by mini-css-extract-plugin
module.exports = {"videoPage":"videoPage___w-GUp","video":"video___Gi9qa","main":"main___3f5Y8","player":"player___1L9cS","drawer":"drawer___55Pdd","carousel":"carousel___294O6"};